import { BadgeStatus } from "shared/constants";

/** Badge status for vehicles and drivers */
export const getBadgeStatus = (entityStatus: BadgeStatus, tableType: BadgeStatus) => {
    let notificationStatus = "";

    if (entityStatus === BadgeStatus.EXPIRED || entityStatus === BadgeStatus.NOTAPPROVED || entityStatus === BadgeStatus.NOT_CREDITED) {
        notificationStatus = "error"
    } else if (entityStatus === BadgeStatus.TOAPPROVE && tableType === BadgeStatus.TO_CREDIT) {
        notificationStatus = "confirm"
    } else if (entityStatus === BadgeStatus.TOAPPROVE && tableType === BadgeStatus.CREDITED) {
        notificationStatus = "warning"
    } else if (entityStatus === BadgeStatus.TO_CREDIT) {
        notificationStatus = "warning"
    } else if (entityStatus === BadgeStatus.APPROVED || entityStatus === BadgeStatus.CREDITED) {
        notificationStatus = "confirm"
    }

    return notificationStatus;

}